import styled from 'styled-components'

export const CardContainer = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  gap: 10px;
`

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`
